"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageReviewInputsSchema = void 0;
exports.deriveReviewStatus = deriveReviewStatus;
exports.summarizePackageReview = summarizePackageReview;
const zod_1 = require("zod");
const package_operator_review_status_1 = require("../Types/package-operator-review-status");
const plan_status_1 = require("./plan-status");
exports.packageReviewInputsSchema = zod_1.z.object({
    packageId: zod_1.z.string(),
    isPublished: zod_1.z.boolean(),
    operatorPlanStatus: zod_1.z.nativeEnum(plan_status_1.PlanStatus).nullable(),
});
function deriveReviewStatus({ isPublished, operatorPlanStatus, }) {
    if (isPublished) {
        return package_operator_review_status_1.PackageOperatorReviewStatus.Published;
    }
    switch (operatorPlanStatus) {
        case null:
            return package_operator_review_status_1.PackageOperatorReviewStatus.NotSubmittedForOperatorReview;
        case plan_status_1.PlanStatus.Pending:
            return package_operator_review_status_1.PackageOperatorReviewStatus.AwaitingOperatorReview;
        case plan_status_1.PlanStatus.Complete:
            return package_operator_review_status_1.PackageOperatorReviewStatus.OperatorReviewComplete;
        case plan_status_1.PlanStatus.Failed:
            return package_operator_review_status_1.PackageOperatorReviewStatus.OperatorReviewFailed;
        case plan_status_1.PlanStatus.Cancelled:
            return package_operator_review_status_1.PackageOperatorReviewStatus.OperatorReviewCancelled;
        default: {
            const exhaustiveCheck = operatorPlanStatus;
            throw new Error(`Unhandled operator plan status: ${String(exhaustiveCheck)}`);
        }
    }
}
function summarizePackageReview(rows) {
    const counts = Object.fromEntries(Object.values(package_operator_review_status_1.PackageOperatorReviewStatus).map((status) => [status, 0]));
    for (const r of rows) {
        counts[deriveReviewStatus(r)]++;
    }
    return counts;
}
//# sourceMappingURL=package-review.js.map